module.exports = __webpack_public_path__ + "1c5ffef292f54f386a55c1a8521f95dc.png";